import { isEmpty } from 'lodash'
import type {
  ACEField,
  CrmAceMappingState,
  FieldsMap,
  MandatoryField,
} from './reducer'

export const validateMandatory = (crmAceMapping: CrmAceMappingState) => {
  const filterAceMapping = (acefields: ACEField[], fieldsMap: FieldsMap) => {
    return acefields
      .filter(
        c =>
          fieldsMap[c.aceKey] &&
          c.requiredForCreation === true &&
          !isEmpty(fieldsMap[c.aceKey].crmKey?.trim()) &&
          c.isHidden === false
      )
      .map(({ aceKey }) => aceKey).length
  }

  const aceMandatory = (acefields: ACEField[]) => {
    return acefields
      .filter(
        ({ requiredForCreation, isHidden }) =>
          requiredForCreation === true && isHidden === false
      )
      .map(({ aceKey }) => aceKey).length
  }
  const hasEmptyMandatoryDefaultValue = (
    crmMandatoryFields: MandatoryField[]
  ) => {
    const hasEmptyDefaultValue = crmMandatoryFields.filter(
      field =>
        !isEmpty(field.crmKey) &&
        isEmpty(field.defaultValue) &&
        isEmpty(field.hardcodedValue)
    )
    return hasEmptyDefaultValue.length > 0 ? true : false
  }
  const hasEmptyStandardValues = Object.entries(
    crmAceMapping.mappingKeys.fields
  )
    .filter(
      ([key]) =>
        crmAceMapping.aceFields.find(({ aceKey }) => aceKey === key)
          ?.mappedDataType === 'picklist'
    )
    .map(([_, value]) => value)
    .some(
      ({ crmKey, standardValuesMap }) =>
        !isEmpty(crmKey?.trim()) &&
        (isEmpty(standardValuesMap) ||
          standardValuesMap?.some(({ crmValue }) => isEmpty(crmValue)))
    )
  if (
    crmAceMapping.aceFields.length > 0 &&
    filterAceMapping(
      crmAceMapping.aceFields,
      crmAceMapping.mappingKeys.fields
    ) == aceMandatory(crmAceMapping.aceFields) &&
    !isEmpty(crmAceMapping.mappingKeys.key?.trim()) &&
    !isEmpty(crmAceMapping.mappingKeys.value?.trim()) &&
    !hasEmptyStandardValues &&
    !hasEmptyMandatoryDefaultValue(crmAceMapping.mappingKeys.crmMandatoryFields)
  ) {
    return true
  } else {
    return false
  }
}
